export default {"src":"/_next/static/media/collectionDefaultRed.f01ea9ad.svg","height":80,"width":80};